import { createContext } from 'react';

const usuariosContext = createContext();

export default usuariosContext;